module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner_stores/banner_stores_nagoya_ekimae-3b59dd1eb2ced09792c342b4b132fbe4.jpg";